export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/product_photography.043739d.svg";